import { Input } from 'components/Form'
import { ChangeEvent } from 'react'
import { noop } from 'utils'
import { AdvancedInputProps, BasicInputGroup } from '.'

export interface NumberInputProps extends AdvancedInputProps {
  value?: number
}

export const AvgInstructionLengthInput = ({
  name,
  label,
  value: milliseconds,
  disabled,
  setFieldValue,
  onBlur = noop,
  error,
  tabIndex,
}: NumberInputProps) => {
  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target
    const mins = Number(value)
    const ms = mins * 60 * 1000 // 60 seconds/min * 1000 ms/second
    setFieldValue(name, ms)
  }
  const minutes =
    milliseconds || milliseconds === 0
      ? milliseconds / 1000 / 60 // 1000 ms/second / 60 seconds/min
      : ''

  const displayText = minutes || minutes === 0 ? `${minutes} minutes` : '-'
  return (
    <BasicInputGroup
      name={name}
      label={label}
      error={error}
      disabled={disabled}
      display={displayText}
      input={
        <>
          <Input
            id={name}
            type="number"
            name={name}
            onChange={handleChange}
            onBlur={onBlur}
            value={minutes}
            aria-invalid={!!error}
            disabled={disabled}
            tabIndex={tabIndex}
            sx={{
              maxWidth: 100,
              display: 'inline',
            }}
          />{' '}
          Minutes
        </>
      }
    />
  )
}
